type SupabaseLikeError = {
  message?: string
  code?: string
  details?: string | null
  hint?: string | null
}

function isSupabaseLikeError(err: unknown): err is SupabaseLikeError {
  return (
    typeof err === 'object' &&
    err !== null &&
    'message' in err &&
    typeof (err as SupabaseLikeError).message === 'string'
  )
}

/** Human-readable message from Error, Supabase PostgrestError, or unknown values. */
export function getErrorMessage(err: unknown, fallback = 'Something went wrong'): string {
  if (err instanceof Error) return err.message || fallback
  if (typeof err === 'string') return err || fallback
  if (isSupabaseLikeError(err)) {
    const msg = err.message || fallback
    if (err.code === '42703' && msg.includes('internal_notes')) {
      return 'Internal notes are not available yet. Ask an admin to apply database migration 202608241800.'
    }
    if (err.code === '42P01' && msg.includes('inbox_item_notes')) {
      return 'Inbox notes are not available yet. Ask an admin to apply database migration 202608251200.'
    }
    if (
      (err.code === '42703' || err.code === 'PGRST202' || /does not exist|could not find/i.test(msg)) &&
      (msg.includes('conversation_id') ||
        msg.includes('phone_call_log_id') ||
        /ensure_inbox_(call_)?chat_channel/i.test(msg) ||
        (msg.includes('channel_type') && msg.includes('inbox')))
    ) {
      return 'Team discuss needs database migration 202609031300. Ask an admin to apply it.'
    }
    if (err.details) return `${msg} (${err.details})`
    return msg
  }
  return fallback
}

/** Convert a Supabase error object into a real Error for throws/catch blocks. */
export function supabaseError(error: SupabaseLikeError, fallback?: string): Error {
  return new Error(getErrorMessage(error, fallback || 'Database error'))
}
